'use client';

import { useEffect } from 'react';

/**
 * Carrega um script de terceiro em idle (requestIdleCallback, com timeout), sem
 * <link rel="preload">: o next/script (beforeInteractive/afterInteractive) pré-carrega o
 * arquivo com prioridade alta e ele disputa banda com o hero (LCP) no mobile.
 * Chamadas feitas antes (dataLayer/gtag, abfPushConfig) ficam na fila e são processadas
 * quando o script chega.
 */
export default function IdleScript({ id, src, crossOrigin, timeout = 2500 }) {
	useEffect(() => {
		if (typeof window === 'undefined' || !src || !id) return undefined;
		if (document.getElementById(id)) return undefined;

		let cancelled = false;
		const load = () => {
			if (cancelled || document.getElementById(id)) return;
			const script = document.createElement('script');
			script.id = id;
			script.src = src;
			script.async = true;
			if (crossOrigin) script.crossOrigin = crossOrigin;
			document.head.appendChild(script);
		};

		const hasIdle = typeof window.requestIdleCallback === 'function';
		const handle = hasIdle
			? window.requestIdleCallback(load, { timeout })
			: window.setTimeout(load, Math.min(timeout, 1500));

		return () => {
			cancelled = true;
			if (hasIdle) window.cancelIdleCallback(handle);
			else window.clearTimeout(handle);
		};
	}, [id, src, crossOrigin, timeout]);

	return null;
}
